import { render } from "./DettaglioSottoProgetto.vue?vue&type=template&id=3aeb9abc&ts=true"
import script from "./DettaglioSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./DettaglioSottoProgetto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__